var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card spinner-wrapper"},[_c('div',{staticClass:"loadingio-spinner-wedges-gdts0xt1jnu"},[_c('div',{staticClass:"ldio-v4qiwrnm3j9"},[_c('div',[_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')])])])])])
}]

export { render, staticRenderFns }